import { useState } from "react";
import OportunidadesDeTrabajoBox from "../../Atoms/OportunidadesDeTrabajoBox/OportunidadesDeTrabajoBox";
import { Button } from "../../Atoms/Button/Button";
import usePosts from "../../../hooks/usePosts";
import Loader from "../../Atoms/Loader/Loader";
import capitalizedFirstLetter from "../../../Services/capitalizedFirstLetter";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content.js";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
// import ChangeableHeader from "../../Molecules/ChangeableHeader/ChangeableHeader";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const OportunidadesDeTrabajo = () => {
  const [showButton, setShowButton] = useState(true);
  const { loading, posts, changePaginationNumb, paginationNumb } = usePosts(
    "carreras",
    3,
    setShowButton
  );
	const { dropdownHeader } = useScrollCtx();
  const { language } = useLanguageCtx();

  return (
    <>
      <ChangeableHeaderV2
       	appearSecondNavbar={dropdownHeader}
        titleBanner={content[language].header_title}
        spanTitleYellow={content[language].header_span_title}
      />
      <div
        className={`max-width flex column center-content-items top-space-section ${
          !showButton && "bottom-space-section"
        }`}
      >
        {loading && paginationNumb === 0 ? (
          <div className="bottom-space-section">
            <Loader />
          </div>
        ) : (
          posts.map((post) => (
            <OportunidadesDeTrabajoBox
              img={post.multimedia[0].url}
              boldText={capitalizedFirstLetter(post.titulo_esp)}
              text={post.contenido_esp}
              buttonRoute={`/carreras/${post.slug}`}
              key={post.slug}
              buttonText={content[language].card_button_text}
            />
          ))
        )}
        {loading && paginationNumb > 0 && (
          <div className="top-space-section">
            <Loader />
          </div>
        )}
      </div>

      {showButton && posts.length > 0 && (
        <div className="top-space-section bottom-space-section flex center-content-items ">
          <Button
            type="button light-blue outline"
            content={content[language].final_button_text}
            clickHandler={changePaginationNumb}
          />
        </div>
      )}
    </>
  );
};

export default OportunidadesDeTrabajo;
